export const deClientPortalValuationPlausibilityHeaderBar = {
    draftWithVersion: 'Entwurf {{version}}',
    options: {
        editObservers: 'Beobachter bearbeiten',
        stopObservingOrder: 'Auftrag nicht mehr beobachten',
        observeOrder: 'Auftrag beobachten',
    },
    emptyObserversMessage: 'Der Auftrag wird aktuell von niemandem beobachtet.',
    observers: {
        header: {
            protectedTooltip: 'Als Zuständige/r dieses Auftrags beobachten Sie ihn automatisch.',
            platformUserTooltip: 'Sie können sich als Plattformnutzer nicht als Beobachter hinzufügen.',
            observingTooltip: 'Sie beobachten diesen Auftrag. Klicken, um nicht mehr zu beobachten.',
            notObservingTooltip: 'Sie beobachten diesen Auftrag nicht. Klicken, um zu beobachten.',
            addObserverTooltip: 'Beobachter hinzufügen',
            observerGroup: 'Beobachter',
            disableObservationAriaLabel: 'Beobachtung deaktivieren',
            enableObservationAriaLabel: 'Beobachtung aktivieren',
        },
        drawer: {
            title: 'Beobachter bearbeiten',
            addObserversLabel: 'Weitere Beobachter hinzufügen...',
            observeOrder: 'Auftrag beobachten',
            observerCount_one: '{{count}} Beobachter des Auftrags',
            observerCount_other: '{{count}} Beobachter des Auftrags',
            editObservers: 'Beobachter bearbeiten',
            responsible: 'Zuständig',
            responsibleRemoveTooltip: 'Auftragszuständige können nicht als Beobachter/in entfernt werden.',
            infoTitle: 'Was sind Beobachter?',
            infoText:
                'Beobachter werden per Mail über alle Neuigkeiten zu einem Auftrag informiert, die sie in ihren Benachrichtigungseinstellungen aktiviert haben. Dazu zählen u.A.: Änderungen des Auftragsstatus, verfügbare Entwürfe, neue Nachrichten und Aufgabenupdates.',
            notificationSettings: 'Zu den Benachrichtigungseinstellungen',
        },
    },
    userLink: {
        me: 'Ich',
        external: 'Extern',
        unknown: 'Nicht festgelegt',
        unavailable: 'Benutzer nicht verfügbar',
        contact: 'Kontakt',
        editOwnContactTooltip: 'Eigene Kontaktdaten bearbeiten',
        emailCopied: 'Email-Adresse kopiert',
        phoneCopied: 'Telefonnummer kopiert',
        addressCopied: 'Adresse kopiert',
        note: 'Anmerkung',
        externalEmailInfo: 'Dieser Kontakt kollaboriert über E-Mail.',
    },
}
